module.exports = __webpack_public_path__ + "0c8bf93e.svg";